import { render } from "./awards.vue?vue&type=template&id=78758714"
import script from "./awards.vue?vue&type=script&lang=js"
export * from "./awards.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__